﻿(function () {
            var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (e) {
                    if (e.isIntersecting) {
                        e.target.classList.add('visible');
                    } else {
                        e.target.classList.remove('visible');
                    }
                });
            }, { threshold: 0.08 });
            document.querySelectorAll('section').forEach(function (el) {
                el.classList.add('fade-in');
                io.observe(el);
            });
        })();
